import { findTable } from '../utils/table';
import { SimpleModal } from './simple-modal.modal';
import { URL as URLModel } from '../integrations/url/url';

export class OrderNowModal extends SimpleModal {
    private readonly _tableNumberWrapper: JQuery<HTMLDivElement>;

    private readonly _tableNumberInput: JQuery<HTMLInputElement>;

    private readonly _tableNumberError: JQuery;

    private readonly _dinnersNumberInput: JQuery<HTMLInputElement>;

    private readonly _dinnersNumberError: JQuery;

    private readonly _continueBtn: JQuery;

    private _replacementLink: URL = new URL(window.location.toString());

    public constructor(container: JQuery) {
        super(container);

        this._tableNumberWrapper = container.find<HTMLInputElement>('.order-now__table');
        this._tableNumberInput = this._tableNumberWrapper.find<HTMLInputElement>('.order-now__table-number');
        this._tableNumberError = this._tableNumberWrapper.find('.table-number-error');

        this._dinnersNumberInput = container.find<HTMLInputElement>('.order-now__dinners-number');
        this._dinnersNumberError = this._container.find('.dinners-number-error');

        this._continueBtn = container.find('.order-now__continue_btn');

        this._addOrderNowEventListeners();
    }

    private _addOrderNowEventListeners() {
        this._tableNumberInput.on('keyup', this._onTableNumberInputKeyup.bind(this));
        this._dinnersNumberInput.on('keyup', () => this._hideDinnersNumberError());
        this._continueBtn.on('click', this._onContinueClick.bind(this));
    }

    private _onTableNumberInputKeyup() {
        this._hideTableNumberError();
        this._toggleContinueBtn();
    }

    private _getTableNumberValue(): string {
        return this._tableNumberInput.val() as string ?? '';
    }

    private _getDinnersNumberValue(): number {
        return Number(this._dinnersNumberInput.val());
    }

    private _toggleContinueBtn() {
        const isValid = this._getTableNumberValue().length > 0;

        if (isValid) {
            this._continueBtn.removeAttr('disabled');
            return;
        }

        this._continueBtn.attr('disabled', 'disabled');
    }

    private _onContinueClick() {
        const tableNumberValue = this._getTableNumberValue();
        if (!tableNumberValue) {
            return;
        }

        const table = findTable(tableNumberValue);
        if (table === undefined) {
            this._showTableNumberError();
            return;
        }

        const params: any[] = [tableNumberValue, this._replacementLink];

        if (this._dinnersNumberInput.length > 0) {
            const dinnersNumberValue = this._getDinnersNumberValue();
            if (dinnersNumberValue === 0) {
                this._showDinnersNumberError();
                return;
            }

            params.push(dinnersNumberValue);
        }

        this.dispatch('OnModalContinue', params);
    }

    private _detectTableNumber() {
        this._tableNumberWrapper.show();

        const [, tableNumber] = URLModel.getUrlData();
        if (!tableNumber) {
            return;
        }

        this._tableNumberInput.val(tableNumber);
        this._tableNumberWrapper.hide();
        this._toggleContinueBtn();
    }

    public open(link: URL) {
        this._replacementLink = link;
        this._hideErrors();
        this._detectTableNumber();

        super.open();
    }

    private _showTableNumberError() {
        this._tableNumberError.show();
    }

    private _hideTableNumberError() {
        this._tableNumberError.hide();
    }

    private _showDinnersNumberError() {
        this._dinnersNumberError.show();
    }

    private _hideDinnersNumberError() {
        this._dinnersNumberError.hide();
    }

    private _hideErrors() {
        this._hideTableNumberError();
        this._hideDinnersNumberError();
    }
}
